import { Box, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const ShareButtons = ({ title }) => {
  const url = window.location.href;

  const handleNativeShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title,
        text: "Check out this job opportunity",
        url,
      });
    }
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(url);
    alert("Job link copied!");
  };

  return (
    <Box display="flex" gap={1} mt={1}>
      <Tooltip title="Share on WhatsApp">
        <IconButton
          color="success"
          onClick={() =>
            window.open(
              `https://wa.me/?text=${encodeURIComponent(
                title + " - " + url
              )}`
            )
          }
        >
          <WhatsAppIcon />
        </IconButton>
      </Tooltip>

      {/* <Tooltip title="Share on LinkedIn">
        <IconButton
          sx={{ color: "#0A66C2" }}
          onClick={() =>
            window.open(
              `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                url
              )}`
            )
          }
        >
          <LinkedInIcon />
        </IconButton>
      </Tooltip> */}

      <Tooltip title="Copy Link">
        <IconButton onClick={copyLink}>
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>

      {navigator.share && (
        <Tooltip title="Share">
          <IconButton onClick={handleNativeShare}>
            📤
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ShareButtons;
